import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SupplierPartService from "../../Controller/SupplierPartController";
import { handleChange, handleSubmit } from "../../Controller/CreateSupplierPartController";
import CreateSupplierStock from "./CreateSupplierStock";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSite from "../../../Common/HelpLink";
function SupplierStockPage({ StockID }) {
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    StockID = localStorage.getItem('StockID');
    const location = useLocation();

    const PartID = StockID;

    const [SupplierStockList, setSupplierStock] = useState([]);
    const [SupplierList, setSupplierData] = useState([]);
    const [modalInstance, setModalInstance] = useState(null);
    const [currentSupplierStock, setCurrentSupplierStock] = useState(null);
    const [selectedSupplierID, setSelectedSupplierID] = useState(null);
    const tableRef = useRef();
    const tableSRef = useRef();
    const [errors, setErrors] = useState({});
    const fetchSupplierStock = async () => {
        try {
            const data = await SupplierPartService.GetAllSupplierParts(redirectCallback, PartID);
            setSupplierStock(data);
            handleCloseModal();
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };

    const fetchSupplier = async () => {
        try {
            const data = await SupplierPartService.GetAvaliableSupplier(redirectCallback, PartID);
            setSupplierData(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };

    useEffect(() => {
        setSupplierStock([]);
        if (PartID > 0) {
            fetchSupplierStock();
        }
        fetchSupplier();
    }, [PartID]);

    useEffect(() => {
        setModalInstance(new window.bootstrap.Modal(document.getElementById('supplierStockModal')));
    }, []);

    const handleCloseModal = () => {
        if (modalInstance) {
            modalInstance.hide();
        }
    };

    const handleEditClick = (history) => {
        setCurrentSupplierStock(history);
        fetchSupplier();
        if (modalInstance) {
            modalInstance.show();
        }
    };

    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation(); // Prevent the row click event

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await SupplierPartService.DeleteSupplierPart(redirectCallback, ID);
                    $(tableRef.current).DataTable().destroy();
                    fetchSupplierStock();
                    fetchSupplier();
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };

    const handleRowClick = (supplierID) => {
        setSelectedSupplierID(supplierID);
    };

    const handleSubmitForm = async (event) => {
        event.preventDefault();

        if (selectedSupplierID) {
            try {
                const formData = {
                    ID: 0,
                    FK_Stock_ID: PartID,
                    SupplierID: selectedSupplierID,
                    mon_CostPrice: "0.00",
                    vc_SupplierCode: "",
                    dec_Quantity: "0.00"
                };

                // Call handleSubmit with the form data
                await SupplierPartService.CreateSupplierPart(redirectCallback, formData);
                setSelectedSupplierID(null);
                fetchSupplierStock();
                fetchSupplier();

            } catch (error) {
                console.error('Error submitting data:', error);
            }
        } else {
            console.error('No supplier selected');
        }
    };

    const HelpLink = localStorage.getItem('HelpLink');

    return (
        <div>
           
           <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-6" style={{ minHeight: "300px", border: "1px solid #dee2e6", overflow: "auto" }}>
                    <div className="table-responsive">
                        <div style={{ maxHeight: "70vh", overflow: "auto" }}>
                            <table className="table m-0 table-hover" ref={tableRef}>
                                <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                                    <tr>
                                        <th data-sortable>Supplier Name</th>
                                        <th data-sortable>Stock Code</th>
                                        <th data-sortable>Cost Price</th>
                                        <th data-sortable>Stock Level</th>
                                        <th style={{ "textAlign": "right" }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {SupplierStockList.map((stock) => (
                                        <tr key={stock.ID} onClick={() => handleEditClick(stock)}
                                            style={{ cursor: 'pointer' }}>
                                            <td>{stock.vc_SupplierName}</td>
                                            <td>{stock.vc_SupplierCode}</td>
                                            <td>{stock.mon_CostPrice}</td>
                                            <td>{stock.dec_Quantity}</td>
                                            <td className={`rightColumn ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`}>

                                                <button style={{ "background": "none", "border": "none" }} className="text-danger" onClick={(event) => handleDeleteClick(event, stock.ID)}>
                                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="col-sm-1 d-flex flex-column align-items-center justify-content-center">

                    <button type="submit" className={`btn btn-secondary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`}  onClick={handleSubmitForm}>&lt;&lt;</button>
                </div>
                <div className="col-sm-5" style={{ minHeight: "300px", border: "1px solid #dee2e6", overflow: "auto",marginRight:"0px" }}>

                    <div className="table-responsive">
                        <div style={{ maxHeight: "70vh", overflow: "auto" }}>
                            <table className="table m-0 table-hover" ref={tableSRef} style={{ "width": "100%" }}>
                                <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                                    <tr>
                                        <th data-sortable>Supplier Name</th>
                                        <th data-sortable>Telephone</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {SupplierList.map((supplier) => (
                                        <tr key={supplier.PK_Supplier_ID} onClick={() => handleRowClick(supplier.PK_Supplier_ID)}>
                                            <td style={selectedSupplierID === supplier.PK_Supplier_ID ? { backgroundColor: '#d3d3d3' } : {}}>{supplier.vc_SupplierName}</td>
                                            <td style={selectedSupplierID === supplier.PK_Supplier_ID ? { backgroundColor: '#d3d3d3' } : {}}>{supplier.vc_Phone}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <CreateSupplierStock
                modalInstance={modalInstance}
                currentSupplierStock={currentSupplierStock}
                onClose={handleCloseModal}
                onSuccess={fetchSupplierStock}
                SupplierList={SupplierList}
                PartID={PartID}
            />
        </div>
    );
}

export default SupplierStockPage;
